import { render, staticRenderFns } from "./CommissionersSaleBidderRegistration.vue?vue&type=template&id=6c1834f2&"
import script from "./CommissionersSaleBidderRegistration.vue?vue&type=script&lang=js&"
export * from "./CommissionersSaleBidderRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports